export const API = "https://api.solarontv.com/";

export const DTAExtension = ".dta";

export const DTAFilename = "data";

export const DTASeparator = "_";

export const SEDGE_TEST =
  "https://monitoringapi.solaredge.com/sites/list?api_key=";
